<section class="main">
    <div class="table-title">
        <div class="head-button">
            <button class="r-btn" type="button" (click)="onRefreshTable()" aria-label="Refresh transactions">
                <i class="icon bi bi-arrow-clockwise"></i>
            </button>
        </div>

        @if (transactionId === null) {
            <div class="date-picker-container">
                @if (selectedStatus) {
                    <button class="status-filter-chip" type="button" (click)="clearStatusFilter()"
                            [attr.aria-label]="'Clear ' + selectedStatusLabel + ' filter'"
                            title="Clear status filter">
                        {{ selectedStatusLabel }} <i class="bi bi-x" aria-hidden="true"></i>
                    </button>
                }
                <button #rangeButton class="date-select-btn" type="button" aria-haspopup="dialog"
                        [attr.aria-expanded]="isDateRangePickerOpened" aria-controls="transaction-range-dialog"
                        (click)="openDateRangePicker()">
                    <i class="bi bi-calendar3" aria-hidden="true"></i>
                    @if (winOlsTransactionService.selectedDateRange(); as range) {
                        <span>{{ range.startDate | date:'dd MMM yyyy, HH:mm' }} – {{ range.endDate | date:'dd MMM yyyy, HH:mm' }}</span>
                    } @else {
                        <span>{{ defaultDateRange.startDate | date:'dd MMM yyyy, HH:mm' }} – {{ defaultDateRange.endDate | date:'dd MMM yyyy, HH:mm' }}</span>
                    }
                </button>
                <dialog #rangeDialog id="transaction-range-dialog" class="range-dialog"
                        aria-labelledby="transaction-range-title" (close)="onDateRangePickerClosed()"
                        (click)="onDateRangeBackdropClick($event)">
                    <div class="range-dialog-heading">
                        <h2 id="transaction-range-title">Select period</h2>
                        <button class="range-close" type="button" aria-label="Close date picker"
                                (click)="closeDateRangePicker()"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
                    </div>
                    <form class="range-form" (ngSubmit)="applyDateRange()">
                        <label>From<input type="datetime-local" name="startDate" [(ngModel)]="draftStart"
                                          [max]="maxDateTime" required></label>
                        <label>To<input type="datetime-local" name="endDate" [(ngModel)]="draftEnd"
                                        [max]="maxDateTime" required></label>
                        @if (draftRangeError) { <p class="range-error" role="alert">{{ draftRangeError }}</p> }
                        <div class="range-dialog-actions">
                            <button class="today-button" type="button" (click)="selectToday()">Today</button>
                            <span></span>
                            <button class="cancel-button" type="button" (click)="closeDateRangePicker()">Cancel</button>
                            <button class="apply-button" type="submit">Apply range</button>
                        </div>
                    </form>
                </dialog>
            </div>
        }
    </div>

    @if (winOlsTransactionService.isLoading()) {
        <app-skeleton-table></app-skeleton-table>
    } @else if (!isTableEmpty()) {
        <div class="table-container"
             infinite-scroll
             [scrollWindow]="false"
             [infiniteScrollDistance]="2"
             (scrolled)="winOlsTransactionService.onScroll()">
            <app-win-ols-transaction-table [winOlsTransactions]="winOlsTransactionService.winOlsTransactions()"
                                           [sortDirectionValues]="winOlsTransactionService.sortDirectionValues()"
                                           [displayedTableHeaders]="winOlsTransactionService.displayedTableHeaders()"
                                           [displayedColumns]="winOlsTransactionService.displayedColumns()"
                                           (changeSortDirection)="changeSortDirection($event)"
                                           (downloadFileFromTable)="downloadFileFromTable($event)">
            </app-win-ols-transaction-table>
        </div>
    } @else {
        <div class="empty-table-wrapper">
            <div class="empty-table">NO RESULTS</div>
        </div>
    }

</section>

